import { useEffect, useRef, useState } from 'react'
import CategoryBanner from '../../components/PageComponents/CategoriesPageComponents/CategoryBanner/CategoryBanner';
import NewCategoryRequest from '../../components/PageComponents/CategoriesPageComponents/CategoryRequestNew/NewCategoryRequest';
import CategorySlider from '../../components/PageComponents/CategoriesPageComponents/CategorySlider/CategorySlider';
import Navbar from '../../components/CommonComponents/Navbar/Navbar';
import { CategoryAndSubcategoryMap, fetchCategories } from './categoriesPageController';
import GGLoaderView from '../../components/UtilityComponents/GGLoaderView/GGLoaderView';
import SnackBar, { SnackTypes } from '../../components/UtilityComponents/SnackBar/SnackBar';
import Footer from '../../components/CommonComponents/Footer/Footer';
import logAnalyticsEvent from '../../services/AnalyticsManager/AnalyticsManager';
import { GGAnalyticsEvents } from '../../services/AnalyticsManager/GGAnalyticsEvents';

const CategoriesPage = () => {
  const [categorySubCategoryMap, setCategorySubCategoryMap] = useState<CategoryAndSubcategoryMap[]>([])
  const [showLoader, setShowLoader] = useState(true);

  // Snackbar based status handling 
  const snackBarRef = useRef<{showSnackbar(): any}>(null)
  const [snackBarParams, setSnackBarParams] = useState({
    message: "",
    state: SnackTypes.error
  });

  const showSnackbar = (message: string, state: SnackTypes ) => {
    setSnackBarParams({message: message, state: state})
    snackBarRef.current?.showSnackbar()
  }

  useEffect(() => {
    document.title = "GenieGig | Categories";
    
    // Aggressive scroll to top - try multiple times
    const forceScrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };

    logAnalyticsEvent(GGAnalyticsEvents.CATEGORIES_PAGE_LOADED);

    fetchCategories().then(categoryMap => {
      setCategorySubCategoryMap(categoryMap);
      setShowLoader(false)


      if (window.location.hash === '#request-new-category') {
        setTimeout(() => {
          document.getElementById('request-new-category')?.scrollIntoView({ behavior: 'smooth' });
        }, 150);
      } else {
        forceScrollToTop();
      }

    }).catch (err => {
      showSnackbar(err, SnackTypes.error)
      setShowLoader(false)
    })

  }, [])

  return (
    <div>
      <Navbar useScrollVersion={true}/>
      <CategoryBanner />
      { showLoader ? 
        <GGLoaderView/> :
        categorySubCategoryMap.map((categoryItem) => (
          <CategorySlider category={categoryItem.category} subcategories={categoryItem.subcategories} key={categoryItem.category.id} />
        ))
      }
      <NewCategoryRequest />
      <Footer />
      <SnackBar ref={snackBarRef} severity={ snackBarParams.state } alertDuration={5000} message={snackBarParams.message} />

    </div>
  )
}

export default CategoriesPage